var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"stuff-item"},[_c('div',{staticClass:"stuff-content"},[_c('img',{staticClass:"stuff-img",attrs:{"src":_vm.detail.cover,"alt":_vm.detail.productName}})]),_c('button',{staticClass:"stuff-btn",class:{ 'stuff-btn-disabled': _vm.disabled },attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleUse}},[_vm._v(" 赠送 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }